<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Rapport clients",
          icon: "bi bi-people",
          route: "reports-customers-index",
        },
        {
          label: "Rapport fournisseurs",
          icon: "bi bi-truck-flatbed",
          route: "reports-suppliers-index",
        },
        {
          label: "Rapport employés",
          icon: "bi bi-person-workspace",
          route: "reports-employees-index",
        },
        {
          label: "Feuille journalière",
          icon: "bi bi-calendar3",
          route: "reports-daily-sheet",
        },
        {
          label: "État journalier",
          icon: "bi bi-clipboard-data",
          route: "reports-daily-status",
        },
      ],
    };
  },
};
</script>
